module.exports = __webpack_public_path__ + "static/media/site_mockup-768x591.2c03bd7c.jpg";